export const Query = {
  // product: (...args) => {
  //   console.log(args);
  //   return null;
  // }
};